import { Button, ButtonGroup, Modal } from 'react-bootstrap';
import React, { useState } from 'react';

const ManageQAPairsModal = (props) => {
    if (!props.show) {
      return null;
    }
    if (props.qaPairs[props.row_id] == null) {
        return null;
    }

    const [qaPairs, setQAPairs] = useState(props.qaPairs);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [itemsPerPage] = useState(5);

    const qaPairsFlattened = qaPairs[props.row_id].flatMap(item => {
            if (item.answer.length > 0) {
                return item.answer.map(answer => ({
                    question: item.question,
                    answer: answer
                }));
            } else {
                return { question: item.question, answer: {'text': '-' }};
            }
        }
    );

    const handleDelete = (question, answer_id) => {
      const data = qaPairs[props.row_id]

      if (!answer_id) {
          qaPairs[props.row_id] = data.filter(pair => pair.question["label"] !== question["label"] || pair.answer.length > 0);
          props.setCompletedQuestions([...props.completedQuestions.filter(q => q["label"] !== question["label"])])
      } else {
          qaPairs[props.row_id] = data.filter(item => {
          // If the answer array was empty from the start, keep this element
          if (item.answer.length === 0) {
            return true;
          }

          // Filter out the answer elements that do not match the given id
          item.answer = item.answer.filter(answerItem => answerItem.id !== answer_id);

          if (item.answer.length === 0) {
              props.setCompletedQuestions([...props.completedQuestions.filter(q => q["label"] !== question["label"])])
          }
          // After filtering, keep the outer element if the answer array is still non-empty
          return item.answer.length > 0;
        });

          const annotFiltered = props.contextAnnotations.filter(ann => ann.id !== answer_id);
          props.setContextAnnotations([...annotFiltered])
      }
        setQAPairs({...qaPairs});
    }

    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };

    const handleSearch = (event) => {
      setSearchTerm(event.target.value);
      setCurrentPage(1);
    };

    const filteredData = qaPairsFlattened.filter((item) =>
      item.question['label'].toLowerCase().includes(searchTerm.toLowerCase())
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const renderItems = currentItems.map((qaItem, index) => (
      <tr key={index}>
        <td>{qaItem.question.label}</td>
        <td>{qaItem.answer.text}</td>
        <td>
          <button onClick={() => handleDelete(qaItem.question, qaItem.answer.id)}>Delete</button>
        </td>
      </tr>
    ));

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
      pageNumbers.push(i);
    }

    return (
      <Modal show={props.show} onHide={() => props.onHide()}>
        <Modal.Header closeButton>
          <Modal.Title>Edit QA Pairs</Modal.Title>
        </Modal.Header>
        <Modal.Body className="wider-modal-body">
          <div className="search-container">
            <input
                className="search-input"
                type="text"
                value={searchTerm}
                onChange={handleSearch}
                placeholder="Search question"
            />
          </div>
          <table className="question-table">
            <thead>
            <tr>
              <th>Question</th>
              <th>Answer</th>
              <th>Actions</th>
            </tr>
            </thead>
            <tbody>{renderItems}</tbody>
          </table>
          <div className="pagination-container">
            <ul className="pagination">
              {pageNumbers.map((number) => (
                  <li key={number}>
                    <button
                        className={`pagination-button ${currentPage === number ? 'active' : ''}`}
                        onClick={() => handlePageChange(number)}
                    >
                      {number}
                    </button>
                  </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ButtonGroup>
            <Button onClick={() => props.storeQAPair()} style={{ margin: '0 5px' }}
                    disabled={qaPairs[props.row_id].length === 0}>Save to dataset</Button>
            <Button onClick={() => props.onHide()}>Close</Button>
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
    );
  }

  export default ManageQAPairsModal;